class UgcRail extends HTMLElement {
  connectedCallback() {
    this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-ugc-card]'));
    if (!this.cards.length) return;

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;

    this.cards.forEach((card) => this.wire(card));

    if (this.autoplay && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            var video = entry.target.querySelector('[data-ugc-video]');
            if (!video) return;
            if (entry.isIntersecting) {
              this.play(entry.target, video);
            } else {
              this.pause(entry.target, video);
            }
          });
        },
        { threshold: 0.6 }
      );

      this.cards.forEach((card) => {
        if (card.querySelector('[data-ugc-video]')) this.observer.observe(card);
      });
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  wire(card) {
    var video = card.querySelector('[data-ugc-video]');
    if (!video) return;

    var toggle = card.querySelector('[data-ugc-toggle]');
    if (toggle) {
      toggle.addEventListener('click', () => {
        if (video.paused) {
          this.play(card, video);
        } else {
          this.pause(card, video);
        }
      });
    }

    var sound = card.querySelector('[data-ugc-sound]');
    if (sound) {
      sound.addEventListener('click', () => {
        video.muted = !video.muted;
        sound.setAttribute('aria-pressed', String(video.muted));
        var use = sound.querySelector('svg');
        if (use) use.classList.toggle('icon--sound-on', !video.muted);
      });
    }
  }

  play(card, video) {
    var attempt = video.play();
    if (attempt && typeof attempt.then === 'function') {
      attempt.then(() => card.classList.add('is-playing')).catch(function () {

      });
    } else {
      card.classList.add('is-playing');
    }
  }

  pause(card, video) {
    video.pause();
    card.classList.remove('is-playing');
  }
}

if (!customElements.get('ugc-rail')) {
  customElements.define('ugc-rail', UgcRail);
}
